// src/services/userService.js
import api from './api';

const userService = {
  // ... (tus otras funciones getUsers, getUserById, etc. déjalas igual) ...
  getUsers: async () => {
    const response = await api.get('/users');
    return response.data;
  },
  getUserById: async (id) => {
    const response = await api.get(`/users/${id}`);
    return response.data;
  },
  createUser: async (userData) => {
    const response = await api.post('/users', userData);
    return response.data;
  },
  updateUser: async (id, userData) => {
    const response = await api.put(`/users/${id}`, userData);
    return response.data;
  },
  updateMyProfile: async (profileData) => {
    const response = await api.put('/users/me', profileData);
    return response.data;
  },
  deleteUser: async (id) => {
    const response = await api.delete(`/users/${id}`);
    return response.data;
  },
  getUserStats: async (id) => {
    const response = await api.get(`/users/${id}/stats`);
    return response.data;
  },

  // ✅ CORRECCIÓN AQUÍ: Usar FormData en lugar de JSON
  uploadAvatar: async (id, file) => {
    const formData = new FormData();
    // 'avatar' debe coincidir con el upload.single('avatar') de tu backend
    formData.append('avatar', file); 

    const response = await api.post(`/users/${id}/avatar`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data', // Importante para archivos
      },
    });
    return response.data;
  },
  uploadMyAvatar: async (file) => {
    const formData = new FormData();
    formData.append('avatar', file);
    const response = await api.post('/users/me/avatar', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },
};

export default userService;
